// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__ftoIo","articleSection":"styles_articleSection__NpNqy","italic":"styles_italic__GHlPS","slideInSearchBar":"styles_slideInSearchBar__wvjKX"};